export const games = {
  gamesTitleDesktop: "打破联盟",
  gamesTitleMobile: "💥 打破联盟",
  gamesSubTitle: "他们不想留下任何东西给别人。",
  recentTitle: "最新游戏",
  recentTitleMobile: "📢 最新游戏",
  recentSubTitle: "尝试我们的新游戏，运气会眷顾你",
  newLabel: "新",
  top10GamesTitle: "热门",
  top10GamesTitle2: "游戏",
  top10GamesSubTitleDesktop: "查看委内瑞拉最受欢迎的游戏",
  top10GamesSubTitleMobile: "🇻🇪 委内瑞拉最受欢迎的十款游戏 🇻🇪",
  randomTitle: "无法决定？",
  randomTitleMobile: "🍀 让运气来决定！",
  randomDescription: "点击播放，让运气选择你的下一个获胜游戏。🎯 选择一个类别，按下按钮... 让运气开始吧！",
  randomDescriptionMobile: "点击播放，让运气选择你的下一个获胜游戏。",
  selectCategory: "选择一个类别",
  randomPlayButton: "开始游戏！",
  randomQuestion: "下一个给你带来好运的游戏会是哪一个？ 🍀",
  randomButton: "前往游戏 🚀",
  topPayingGamesTitle: "高额支付游戏",
  topPayingGamesSubTitle: "他们在撒钱",
  recentlyPlayedTitle: "继续游戏",
  recentlyPlayedSubTitle: "从上次中断的地方继续",
  lotteryGamesTitle: "彩票游戏",
  lotteryGamesSubTitle: "尝试我们的彩票游戏，试试您的运气",
  allGamesTitle: "所有游戏",
  dontMiss: "不要错过",
  dontMissTournaments: "锦标赛、免费旋转、促销等。",
  tournamentRules: "规则",
  // Multi-Game Floating Button translations
  multiGameFloatingButton: "快速游戏",
  quickGamesTitle: "快速游戏",
  quickGamesDescription: "在等待主游戏时继续游戏！",
  hideQuickGames: "隐藏",
  minimizeQuickGames: "最小化",
  playNow: "立即游戏",
  noQuickGamesAvailable: "暂时没有可用的游戏",
  unknownGame: "未知游戏",
  unknownProvider: "未知",
  loadingGames: "正在加载游戏...",
};
